module.exports = __webpack_public_path__ + "img/112.169aed81.svg";